import Vue from 'vue';
import numeral from 'numeral';
Vue.use(numeral); 
/*import footer from "./components/sharedComponents/footerComponents/footer.vue"*/
import header from './components/sharedComponents/headerComponents/header.vue'
//import navbar from './components/sharedComponents/navbarComponents/navbar.vue'
/*import navbar2 from './components/sharedComponents/navbarComponents/navbar2.vue'*/
import responsiveHeader from './components/sharedComponents/headerComponents/responsiveHeader.vue' 
import VueQRCodeComponent from 'vue-qrcode-component'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
/*import footerFixNav from './components/sharedComponents/footerComponents/footerFixNav.vue';*/
import loaderComponent from "./components/sharedComponents/loaderComponents/loaderComponent.vue"; 

export const registerGlobalComponents = function () { 
/*    Vue.component('footer-component', footer);*/
    Vue.component('header-component', header);
    //Vue.component('navbar-component', navbar);
/*    Vue.component('navbar2-component', navbar2);*/
    Vue.component('responsive-header-component', responsiveHeader);
    /*Vue.component('footer-fixnav-component', footerFixNav); */
    Vue.component('loader-component', loaderComponent);
    Vue.component('qr-code', VueQRCodeComponent); 
    Vue.component('date-picker', VuePersianDatetimePicker);
}